$(function () {
  ("use strict");
  $.ajaxSetup({
    cache: false,
    data: {
      csrftoken: Cookies.get(cookie_pre + "csrfcookie"),
    },
  });

  //========================================================//
  // LAUNCH MODAL
  //========================================================//
  $(".btnModal")
    .off("click")
    .on("click", function (event) {
      event.preventDefault();
      let id = $(this).data("id");
      let formData = new FormData($("#frmPoster")[0]);
      formData.append("id", id);

      //ajax call to open modal
      $.ajax({
        type: "POST",
        url: "/ajax/modalResource/",
        data: formData,
        processData: false,
        contentType: false,
      }).done(function (data) {
        $("#myModal #modal-content").removeClass("preloading").html(data);
        let popup = new Foundation.Reveal($("#myModal"));
        popup.open();
      });
    });

  //========================================================//
  // ACCORDION ICON TOGGLE
  //========================================================//
  $(".accordion-title").on("click", function () {
    const iconObj = $(this).find(".accordion-icon").find(".svg-inline--fa");
    // first set all the icons to down
    $(".accordion-icon")
      .find(".svg-inline--fa")
      .removeClass("fa-angle-up")
      .addClass("fa-angle-down");

    //set the title of the items
    $(".accordion-title").attr("title", "Click to expand section");

    // then set the clicked icon to up
    iconObj.removeClass("fa-angle-down").addClass("fa-angle-up");

    $(this).attr("title", "Expanded section");
  });

  //========================================================//
  // CLOSE MODAL
  //========================================================//
  if ($(".close-reveal-modal").length > 0) {
    $(".close-reveal-modal").on("click", function () {
      $("body").removeClass("modal-open");
      //reset the modal and add the preloader
      $("#modal-content").html(
        '<div class="text-center"><em class="fa fa-spinner fa-spin fa-5x fa-fw fa-pulse"></em><span class="sr-only">Loading...</span></div>'
      );
    });
  }
});
